<template>
  <div class="yh-page">
    <el-card>
      <el-row slot="header" type="flex" justify="start" align="middle" class="p-3" :gutter="10">
          <el-col :span="4">
            <el-radio-group v-model="query.remark_status" @change="handleSearch" size="small">
              <el-radio-button label="0">全部</el-radio-button>
              <el-radio-button label="1">已核实</el-radio-button>
              <el-radio-button label="2">未核实</el-radio-button>
              <el-radio-button label="3">未填写</el-radio-button>
            </el-radio-group>
          </el-col>
          <el-col :span="6">

              <el-input placeholder="输入船名或保单号或者客户名称进行搜索..." v-model.trim="query.search"
                          @keyup.enter.native="handleSearch">
                  <el-button slot="append" icon="el-icon-search" :loading="searching" @click="handleSearch">搜索</el-button>
              </el-input>
          </el-col>
          <el-col :span="3">
            <el-select v-model="query.group" placeholder="请选择业务部门" filterable clearable @change="handleSearch">
              <el-option
                v-for="item in business_area_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-col>
     
          <el-col :span="3.5">
              <el-date-picker
                  v-model="query.begin_date"
                  type="date"
                  value-format="yyyy-MM-dd"
                  clearable @change="handleSearch"
                  placeholder="选择开始日期">
              </el-date-picker>
              </el-col>
              <el-col :span="3.5">
              <el-date-picker
                  v-model="query.end_date"
                  type="date"
                  value-format="yyyy-MM-dd"
                  clearable @change="handleSearch"
                  placeholder="选择结束日期">
              </el-date-picker>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary" size="small" @click="exportReport(1)">导出已填写数据</el-button>
          </el-col>

          <el-col :span="2">
            <el-button type="primary" size="small" @click="exportReport(2)">导出未填写数据</el-button>
          </el-col>

            <el-col :span="1.5">
              <el-button type="primary" size="small" @click="openBatchVisible">批量填写未续保原因</el-button>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" size="small" @click="openBatchFollowUpVisible">批量填写回访数据</el-button>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" size="small" @click="openBatchUploadVisible">批量上传附件</el-button>
            </el-col>
        </el-row>
        <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText"
                  fit highlight-current-row class="w-100" @selection-change="handleSelectionChange">
          <!-- 选择 -->
          <el-table-column align="left" type="selection" width="50px"></el-table-column>
  
          <!-- 船舶名称 -->
          <el-table-column align="left" label="保单id" width="100px">
            <template slot-scope="scope">
              <span>{{scope.row.id}}</span>
            </template>
          </el-table-column>

        <el-table-column align="left" label="船舶名称">
          <template slot-scope="scope">
            <span>{{ scope.row.ship_name }}</span>
          </template>
        </el-table-column>

        <!-- 保险公司 -->
        <el-table-column align="left" label="保单号" >
          <template slot-scope="scope">
            <span>{{ scope.row.policy_number }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="险种" >
          <template slot-scope="scope">
            <span>{{ scope.row.insurance_type }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="起保日期" >
          <template slot-scope="scope">
            <span>{{ scope.row.effective_date }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="到期日期" >
          <template slot-scope="scope">
            <span>{{ scope.row.expiration_date  }}</span>
          </template>
        </el-table-column>

          
        <!-- 险种 -->
        <el-table-column align="left" label="未续保客户" >
          <template slot-scope="scope">
            <span>{{ scope.row.reason_dict.customer }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="联系方式" >
          <template slot-scope="scope">
            <span>{{ scope.row.reason_dict.mobile }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="业务部门" >
          <template slot-scope="scope">
            <span>{{ scope.row.business_area }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="未续保原因" >
          <template slot-scope="scope">
            <span>{{ scope.row.reason_dict.reason }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="备注（其他未续报原因）" >
          <template slot-scope="scope">
            <span>{{ scope.row.reason_dict.other_reason }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="回访状态" >
          <template slot-scope="scope">
            <span>{{ scope.row.reason_dict.remark_status  }}</span>
          </template>
        </el-table-column>
           
        <el-table-column property="operation" label="操作" width="300">
          <template slot-scope="scope">
              <el-tooltip effect="light" content="填写未续保原因" placement="top-start">
                <el-button type="text" class="pr-1" @click="openVisible(scope.row)">
                  <i class="el-icon-arrow-up"></i>
                </el-button>
              </el-tooltip>
              <el-tooltip effect="light" content="填写回访记录" placement="top-start" v-if="scope.row.reason_dict.mobile">
                <el-button type="text" class="pr-1" @click="openFollowUpVisible(scope.row)">
                  <i class="el-icon-s-promotion"></i>
                </el-button>
              </el-tooltip>  
              <el-tooltip effect="light" content="查看详细信息" placement="top-start">
                  <el-button type="text" class="pr-1" @click="handleSuccess(scope.row)">
                      <i class="el-icon-view"></i>
                  </el-button>
              </el-tooltip> 
              <el-tooltip effect="light" content="上传" placement="top-start">
                <el-button type="text" class="pr-1" @click="handleUpload(scope.row)">
                  <i class="el-icon-upload"></i>
                </el-button>
              </el-tooltip>

              </template>
          </el-table-column>
        </el-table>
      </el-card>
      <pagination ref="pagination" :size.sync="query.limit" :offset.sync="query.offset" :total="total" @updateList="getList"></pagination>
      <el-dialog title="填写未续保原因" :visible.sync="assignVisible" width="1000px" top="20px">
      <el-form ref="dataForm" :model="formData" label-position="top" label-width="120px" class="mx-30">
        <el-form-item label="请选择未续保原因">
                  <el-select v-model="formData.reason" placeholder="请选择未续保原因" clearable value-key="id" style="width: 80%;">
                    <el-option v-for="at in reasons" :key="at.name"
                        :value="at.name" ></el-option>
                  </el-select>
        </el-form-item>
        <el-form-item label="选择客户(从联系人中获取)">
                <el-select v-model="contact" placeholder="请选择联系人" remote filterable  clearable value-key="id" :loading="contact_loading" :remote-method="remoteContactMethod" @change="handleContactInfo">
                  <el-option v-for="(g, index) in contact_list" :key="index" 
                      :label="g.name" :value="g" ></el-option>
                </el-select>
              </el-form-item>
        <el-form-item label="客户名称" prop="mobile">
                  <el-input v-model="formData.customer" style="width: 80%;"/>
        </el-form-item>
        <el-form-item label="请选择联系方式类型">
                  <el-select v-model="formData.mobile_type" placeholder="请选择联系方式类型" clearable value-key="id" style="width: 80%;">
                    <el-option v-for="at in mobile_types" :key="at.value" 
                        :value="at.value" :label="at.name"></el-option>
                  </el-select>
        </el-form-item>
        <el-form-item label="客户的联系方式 (固定电话格式为四位区号加 “-” 加八位号码，例如：0000-88888888。)" prop="mobile">
                  <el-input v-model="formData.mobile" style="width: 80%;"/>
        </el-form-item>
        <el-form-item label="备注" prop="other_reason">
                <el-input  type="textarea" v-model="formData.other_reason" style="width: 80%;"/>
        </el-form-item>
        <!-- <el-form-item label="上传附件">
          <el-button  @click="handleUploadBatch"> 上传附件</el-button>
        </el-form-item> -->
        <el-form-item style="margin-bottom: 0px">
        <span style="float: right">
          <el-button size="small" @click="cancelData">取消</el-button>
          <el-button type="primary" size="small" @click="updateData">确定</el-button>
        </span>
      </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="批量上传附件" :visible.sync="uploadBatchVisible">
      <el-form ref="dataForm" :model="formData" label-position="top">
        <el-form-item label="已选船舶">
          <el-input v-model="select_ship_name" style="width: 80%;" disabled />
        </el-form-item>
        <el-form-item label="上传附件">
          <el-button  @click="handleUploadBatch" type="primary"> 上传附件</el-button>
        </el-form-item>
        <el-form-item style="margin-bottom: 0px">
        <span style="float: right">
          <el-button size="small" @click="canceluploadBatchVisible">取消</el-button>
        </span>
      </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="填写回访记录" :visible.sync="followUpVisible" width="900px" top="20px">
      <el-form ref="dataForm" :model="formData" label-position="top" label-width="120px" class="mx-30">
        <el-form-item label="客户未续保原因与业务同事填写原因是否一致">
                  <el-select v-model="formData.follow_reason" placeholder="客户未续保原因与业务同事填写原因是否一致" clearable value-key="id" style="width: 80%;">
                    <el-option v-for="at in follow_reasons" :key="at.name"
                        :value="at.name" ></el-option>
                  </el-select>
        </el-form-item>
        <el-form-item label="回访内容" prop="remark">
                  <el-input  type="textarea" v-model="formData.remark" style="width: 80%;"/>
        </el-form-item>
        <el-form-item label="客户对跟进同事的评分" prop="score">
                  <el-input type="number" v-model="formData.score" style="width: 80%;"/>
        </el-form-item>
        <el-form-item style="margin-bottom: 0px">
        <span style="float: right">
          <el-button size="small" @click="closeData">取消</el-button>
          <el-button type="primary" size="small" @click="updateScoreData">确定</el-button>
        </span>
      </el-form-item>
      </el-form>
    </el-dialog>
    <upload-dialog ref="upload"
              :object-name="object_name"
              :file-type-list="file_type_list"
              object-type="policy.notrenewingreason"
              :object-id="apply_id"
              :is-upload="true"
              @uploaded="handleAppended">
          </upload-dialog>
    </div>
  </template>
  <script>
  import Pagination from '@/components/Pagination'
  import { notRenewingReasonList,createNotRenewing,updateNotRenewing,exportNotRenewingDetail,batchUpdateNotRenewing} from '@/api/policy'
  import UploadDialog from "@/components/UploadDialog"
  import { fetchList as fetchContactList } from '@/api/contact'
  import { fetchFileTypeList } from "@/api/common"
  import { fetchGroupNameList } from "@/api/group";
import { json } from 'body-parser';
import { all } from 'q';

export default {
name: "NotRenewingReason",
  components: {
    Pagination,
    UploadDialog,
  },
  data(){
    return {
      query:{
        search: '',
        limit: 10,
        offset: 0,
        begin_date:'',
        end_date:'',
        remark_status:0,
      },
      loadingText: '正在加载数据，请稍等...',
      loading: false,
      object_name:"",
      apply_id:'',
      contact:null,
      file_type_list:[],
      multipleSelection:[],
      policy_ids:[],
      ids:[],
      mobile_types:[
        {name:"手机号码",value:1},
        {name:"固定电话",value:2}
      ],
      business_area_list: [],
      contact_list: [],
      formData:{},
      select_ship_name:'',
      searching: false,
      opera_type:null,
      follow_type:null,
      followUpVisible:false,
      contact_loading: false,
      assignVisible:false,
      uploadBatchVisible:false,
      total: 0,
      list:[],
      follow_reasons:[
          {name: "是"},
          {name: "1.【不定值】保险公司不同意定值投保。"},
          {name: "2.【保费高】保费和上年保费相比，升幅较大。"},
          {name: "3.【承保条件不好】合作的保险公司承保条件不理想甚至不报价。"},
          {name: "4.【退费少】客户选择其他退费更多的渠道或者是因为我们没有手续费（如东海大连／人保）客户选择其他渠道投保。"},
          {name: "5.【定损不满意】客户对定损不满意。"},
          {name: "6.【停航】如东莞有7成砂船已经停航，有部分船舶9月份已经开始停止营运。"},
          {name: "7.【船舶出售】船舶发生出售，新船东选择其他渠道投保。"},
          {name: "8.【转其他部门投保】由于船舶发生出售，新船东刚好也认识其他部门同事，此种情况，作为公司整体其实不算流失业务。"},
          {name: "9.【船公司指定投保】船公司以各种理由要求船东回公司办理保险。"},
          {name: "10.【船舶更名系统识别不了】船舶变更名称，但系统没有同步更新，误判为业务流失。"},
          {name: "11.【船舶拆解】船东将老旧船拆解不再续保。"},
          {name: "12.【保险公司抢业务】如东海广分报给客户的条件优于报给我们，客户选择直接找东海投保。"},
          {name: "13.【客户有亲友做保险】。"},
          {name: "14.【联系不上客户】如客户因违法活动被送入监狱或客户去世。"},
          {name: "15.【船舶未通过年检】如老旧船未有通过船舶年检，证书不齐保险公司不报价。"},
          {name: "16.【客户不租船舶】如船代货代公司不再期租该船舶，船东自己选择其他渠道投保。"},
          {name: "17.【客户资金困难】由于客户资金紧张，未有钱续保。"},
          {name: "18.【银行贷款指定投保】客户申请船舶贷款，银行要求在合作保险公司投保。"},
          {name: "19.【忘记通知续保】本人忘记通知客户及时续保，客户转其他地方投保。"},
          {name: "20.【对客服同事服务不满意】客户对客服同事服务（包括服务态度不好、回复不及时、索赔指引不清晰等）不满意。"},
          {name: "21.【对本人服务不满意】由于自身缺乏服务意识怠慢客户。"},
          {name: "22.【对承保工作不满意】认为承保手续繁琐、保单寄送效率低等。"},
          {name: "23.【其他原因】非以上原因造成的无续保，请在备注栏注明原因。"},
      ],
      reasons:[
          {name: "1.【不定值】保险公司不同意定值投保。"},
          {name: "2.【保费高】保费和上年保费相比，升幅较大。"},
          {name: "3.【承保条件不好】合作的保险公司承保条件不理想甚至不报价。"},
          {name: "4.【退费少】客户选择其他退费更多的渠道或者是因为我们没有手续费（如东海大连／人保）客户选择其他渠道投保。"},
          {name: "5.【定损不满意】客户对定损不满意。"},
          {name: "6.【停航】如东莞有7成砂船已经停航，有部分船舶9月份已经开始停止营运。"},
          {name: "7.【船舶出售】船舶发生出售，新船东选择其他渠道投保。"},
          {name: "8.【转其他部门投保】由于船舶发生出售，新船东刚好也认识其他部门同事，此种情况，作为公司整体其实不算流失业务。"},
          {name: "9.【船公司指定投保】船公司以各种理由要求船东回公司办理保险。"},
          {name: "10.【船舶更名系统识别不了】船舶变更名称，但系统没有同步更新，误判为业务流失。"},
          {name: "11.【船舶拆解】船东将老旧船拆解不再续保。"},
          {name: "12.【保险公司抢业务】如东海广分报给客户的条件优于报给我们，客户选择直接找东海投保。"},
          {name: "13.【客户有亲友做保险】。"},
          {name: "14.【联系不上客户】如客户因违法活动被送入监狱或客户去世。"},
          {name: "15.【船舶未通过年检】如老旧船未有通过船舶年检，证书不齐保险公司不报价。"},
          {name: "16.【客户不租船舶】如船代货代公司不再期租该船舶，船东自己选择其他渠道投保。"},
          {name: "17.【客户资金困难】由于客户资金紧张，未有钱续保。"},
          {name: "18.【银行贷款指定投保】客户申请船舶贷款，银行要求在合作保险公司投保。"},
          {name: "19.【忘记通知续保】本人忘记通知客户及时续保，客户转其他地方投保。"},
          {name: "20.【对客服同事服务不满意】客户对客服同事服务（包括服务态度不好、回复不及时、索赔指引不清晰等）不满意。"},
          {name: "21.【对本人服务不满意】由于自身缺乏服务意识怠慢客户。"},
          {name: "22.【对承保工作不满意】认为承保手续繁琐、保单寄送效率低等。"},
          {name: "23.【其他原因】非以上原因造成的无续保，请在备注栏注明原因。"},
      ]
    }
  },
  methods: {
      openBatchUploadVisible(){
        if (this.multipleSelection.length === 0){
            this.$error_message("请选择需要上传附件的业务！")
            return
          }
        let select_ship_name = ''
        this.multipleSelection.forEach(item => {
            if (item.reason_dict.reason_id){
              select_ship_name = select_ship_name + " " + item.ship_name
            }             
          })
        this.select_ship_name = select_ship_name
        this.uploadBatchVisible = true
      },
      handleUpload() {
              this.$refs.upload.handleOpen()
              },
      canceluploadBatchVisible(){
        this.uploadBatchVisible = false
      },
      handleContactInfo(value){
        if (value){
          this.formData.mobile = value.mobile
          this.formData.customer = value.name
        }
      },
      remoteContactMethod(query) {
        if (query !== '') {
          this.contact_loading = true
          setTimeout(() => {
            fetchContactList({'search': query}).then(res => {
              this.contact_list = res
              this.contact_loading = false
            }).catch(err => {
              this.contact_loading = false
              this.$error_message(err)
            })
          }, 200);
        } else {
          this.contact_list = [];
        }
      },
      setQueryStorage() {
        window.localStorage.setItem('query', JSON.stringify(this.query))
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;     
      },
      exportReport(value){
          this.downloading = true
          exportNotRenewingDetail({"type":value,"query":this.query})
              .then(res => {
              let link = document.createElement('a')
              link.style.display = 'none'

              let blob = new Blob([res])
              link.href = URL.createObjectURL(blob)
              link.download = '未续保业务填写情况.xlsx'
              document.body.appendChild(link)

              link.click()
              URL.revokeObjectURL(blob)
              document.body.removeChild(link)
              
              this.downloading = false
              this.$message.success("下载完成")
              })
              .catch(error => {
              this.downloading = false
              this.$error_message(error)
              })
      },
      loadData() {
        this.loading = true
        let p = []
        p.push(fetchFileTypeList({file_type: "nrr"}))
        p.push(fetchGroupNameList())

          Promise.all(p)
          .then(res => {
            this.file_type_list = res[0]
            this.business_area_list = res[1]
          })
          .catch(err => {
            this.loading = false
            this.$error_message(err)
          })
        },
        handleAppended(fileList) {
          this.$message({type: 'success', message: '文件上传成功!'})
        },
        handleUpload(row) {
          this.apply_id = row.reason_dict.reason_id
          this.object_name = row.ship_name
          this.$refs.upload.handleOpen()
        },
        handleUploadBatch() {
          let reason_ids = []
          this.multipleSelection.forEach(item => {
              if (item.reason_dict.reason_id){
                reason_ids.push(item.reason_dict.reason_id)
              }             
            })
          this.apply_id = reason_ids
          this.object_name = "回访文件"
          this.$refs.upload.handleOpen()
        },
        updateScoreData(){
          if (this.follow_type === 1){
            updateNotRenewing(this.formData)
                .then(resp => {
                    this.getList()
                    this.$message.success('填写成功！')
                    this.followUpVisible = false
                    this.formData = {}
                    this.ids = []
                })
                .catch(error => {
                this.$message.error(error)
                })
          }
          else{
            this.multipleSelection.forEach(item => {
                this.ids.push(item.reason_dict.reason_id)
              })
            this.formData.ids = this.ids
            batchUpdateNotRenewing(this.formData)
                .then(resp => {
                    this.getList()
                    this.$message.success('填写成功！')
                    this.followUpVisible = false
                    this.formData = {}
                    this.ids = []
                })
                .catch(error => {
                this.$message.error(error)
                })
          }        
        },
        updateData(){
            console.log(this.formData)
            if (this.formData.mobile_type === '' && this.formData.mobile){
              this.$error_message("请选择联系方式的类型！")
              return
            }
            let str_moblie = this.formData.mobile.toString()    
            if (this.formData.mobile_type === 1){
              let str_a = str_moblie.slice(0,1)
              if (this.formData.mobile.length != 11 || str_a !== '1'){
                this.$error_message("请输入正确的手机号码！")
                return
              }
            }
            if (this.formData.mobile_type === 2){
              let str_a = str_moblie.slice(4,5)
              console.log(str_a)
              if (this.formData.mobile.length != 13 || str_a !== '-'){
                this.$error_message("请输入正确的固定电话格式！")
                return
              }
            }
            if (this.opera_type === 2){
                  this.multipleSelection.forEach(item => {
                      this.policy_ids.push(item.id)
                  })
                  this.formData.policy_table_id = this.policy_ids
            }
            createNotRenewing(this.formData)
                .then(resp => {
                    this.getList()
                    this.$message.success('填写成功！')
                    this.assignVisible = false
                    this.formData = {}
                    this.policy_ids = []
                })
                .catch(error => {
                this.$message.error(error)
                })
        },
        openVisible(row){
            this.opera_type = 1            
            this.formData.policy_table_id = row.id
            this.formData.type = 1
            this.formData.mobile_type = 1
            this.assignVisible = true
            
        },
        openBatchVisible(){
          this.opera_type = 2
          if (this.multipleSelection.length === 0){
            this.$error_message("请选择填写的业务！")
            return
          }
            this.assignVisible = true          
            this.formData.type = 2
            this.formData.mobile_type = 1
        },
        openFollowUpVisible(row){
            this.follow_type = 1
            this.followUpVisible = true
            this.formData.id = row.reason_dict.reason_id
        },
        openBatchFollowUpVisible(){
          let is_null = false
          this.follow_type = 2
          if (this.multipleSelection.length === 0){
            this.$error_message("请选择填写的业务！")
            return
          }
          this.multipleSelection.forEach(item => {
            if (JSON.stringify(item.reason_dict) === '{}'){        
              is_null = true
            }
          })
          if (is_null){
            this.$error_message("选中的业务有未填写未续保原因的，玩法填写回访数据！")
            return
          }

        this.followUpVisible = true
      },

      getList() {
          this.loading = true
          notRenewingReasonList(this.query)
              .then(resp => {
              this.list = resp.results
              this.total = resp.count
              this.loading = false
              })
              .catch(error => {
              this.loading = false
              this.$message.error(error)
              })
      },
      handleSuccess(row) {
        this.setQueryStorage()
        this.$router.push({ name: 'NotRenewingReasonDetail', query: {'id': row.reason_dict.reason_id}})
      },
      closeData(){
        this.followUpVisible = false
        this.formData = {}
      },
      cancelData() {
          this.assignVisible = false
          this.formData = {}
      },
      handleSearch(val) {
          this.getList()
          this.$refs.pagination.backNumOne()
      },
      },
      created(){
      this.loadData()
      this.query = JSON.parse(window.localStorage.getItem('query')) || {
        search: '',
        limit: 10,
        offset: 0,
        begin_date:'',
        end_date:'',
        remark_status:0,
      }
      this.getList()
      }
}
</script>

<style scoped>
li.el-select-dropdown__item {
  font-size: 20px !important;
} 
</style>
